import { useColumnsInstalacionesOT } from '@/erp/tecnico/orden-trabajo/shared/hooks';
import { SingleTableBoxScene } from '@/shared/components/ui';
import { EstadoOrdenTrabajoCodigoEnum } from '@/shared/interfaces';
import TablaInstalacionComponente from '../componente/TablaInstalacionComponente';

const InstalacionRechazadoPage = () => {
  const { pylInstallPrerechazadaPendingColumns } = useColumnsInstalacionesOT();

  return (
    <SingleTableBoxScene title="Instalación Rechazado">
      <TablaInstalacionComponente
        columns={pylInstallPrerechazadaPendingColumns as any}
        estadoInstalacion={EstadoOrdenTrabajoCodigoEnum.RECHAZADA}
      />
    </SingleTableBoxScene>
  );
};

export default InstalacionRechazadoPage;
